import api from "../axios_service.js";

export async function getSolicitacoesServicos(filtros) {
  const response = await api.get(
    `/gestor/solicitacoes-servicos${filtros ? filtros : ""}`
  );
  return response.data.result;
}

export function putMsgLida(id) {
  return api.put(`/gestor/solicitacoes-servicos/${id}`);
}

export async function getQtdNaoLidas(filtros) {
  const response = await api.get(`/solicitacoes-servicos-count${filtros ? filtros : ""}`);
  return response.data.result;
}
